import * as TaskActions from '../constants/taskConstants';

const InitialState = {
    taskList:[],
    lastClickedElement: {
		id: null,
	},
};

const task = (state = InitialState, action) => {
    switch(action.type) {

        case TaskActions.SET_TASKS:
            return { ...state, taskList :action.data }

        case TaskActions.SET_LAST_CLICKED_ELEMENT:
            return {
                ...state,
                lastClickedElement: action.data,
            };

        case TaskActions.CLEAR_STATE:
            return {
                ...InitialState,
            };

        default : 
            return {
                ...state
            };
    }
}

export default task;